import {
  CLEAR_DOC_RECOMMENDATION,
  DOC_RECOMMENDATION_FAILURE,
  DOC_RECOMMENDATION_REQUEST,
  DOC_RECOMMENDATION_SUCCESS,
} from '../../constants/actionTypes';

const initialState = {};

export const recommendationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOC_RECOMMENDATION_REQUEST:
    case CLEAR_DOC_RECOMMENDATION:
      return clearRecommendation(state, action);

    case DOC_RECOMMENDATION_FAILURE:
    case DOC_RECOMMENDATION_SUCCESS:
      return saveRecommendation(state, action);

    default:
      return state;
  }
};

function saveRecommendation(state, action) {
  const { requestInfo, result, error } = action;
  const { id, resourceType } = requestInfo;
  return {
    [resourceType]: {
      ...state?.[resourceType],
      [id]: {
        recommendation: result?.output?.response,
        error,
      },
    },
  };
}

function clearRecommendation(state, action) {
  const { requestInfo, payload } = action;
  const { id, resourceType } = requestInfo || payload;
  return {
    [resourceType]: {
      ...state?.[resourceType],
      [id]: {},
    },
  };
}
